import { BaseAction } from "../../../core/actions/BaseAction";
import { getRuntimeConfig } from "../../../Lib/Config/RuntimeConfig";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IAppDownloadLink } from "../../../Orchestrator/Types/Interface/ICmsAppDownloadLink";
import { getCmsAppDownloadLinksAndQrAction } from "./GetCmsAppDownloadLinksAndQrAction";

const DEFAULT_PLAY_STORE_QR_LINK = "/images/qr-code-GOOGLE.png";
const DEFAULT_APP_STORE_QR_LINK = "/images/qr-code-APPLE.png";

class GetAppDownloadLinkAction extends BaseAction<IAppDownloadLink | null, void> {
  override async run(): Promise<IAppDownloadLink | null> {
    let appDownloadLinkResponse: IAppDownloadLink | null = null;
    try {
      await getCmsAppDownloadLinksAndQrAction.execute();
      const runtimeConfig = await getRuntimeConfig();
      appDownloadLinkResponse = {
        playStoreLink: runtimeConfig?.NEXT_PUBLIC_ANDROID_APP_URL ?? "#",
        appStoreLink: runtimeConfig?.NEXT_PUBLIC_IOS_APP_URL ?? "#",
        playStoreQrLink: DEFAULT_PLAY_STORE_QR_LINK,
        appStoreQrLink: DEFAULT_APP_STORE_QR_LINK
      }

      if (isActionRunSuccessfully(getCmsAppDownloadLinksAndQrAction)) {
        const cmsResult = getCmsAppDownloadLinksAndQrAction.result;
        if (cmsResult?.data?.app_store_link) {
          appDownloadLinkResponse.appStoreLink = cmsResult.data.app_store_link;
        }
        if (cmsResult?.data?.play_store_link) {
          appDownloadLinkResponse.playStoreLink = cmsResult.data.play_store_link;
        }
        if (cmsResult?.data?.app_store_qr?.url) {
          appDownloadLinkResponse.appStoreQrLink = cmsResult.data.app_store_qr.url;
        }
        if (cmsResult?.data?.play_store_qr?.url) {
          appDownloadLinkResponse.playStoreQrLink = cmsResult.data?.play_store_qr.url;
        }
      }
    } catch (error: any) {
      appDownloadLinkResponse = {
        playStoreLink: "#",
        appStoreLink: "#",
        playStoreQrLink: DEFAULT_PLAY_STORE_QR_LINK,
        appStoreQrLink: DEFAULT_APP_STORE_QR_LINK
      };
      console.error("Error fetching routes:", error);
    } finally {
      updateRecoilState("appDownloadLinkAtom", appDownloadLinkResponse);
      return appDownloadLinkResponse;
    }
  }
}

export const getAppDownloadLinkAction = new GetAppDownloadLinkAction()
